import React from 'react';
import PracticeDetailPage from './PracticeDetailPage';

export default function PracticeHomeFragrance() {
  return (
    <PracticeDetailPage
      practiceId="home-fragrance-air-care"
      canonicalPath="/practice/home-fragrance-air-care"
    />
  );
}
